import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import './themeDefaults';

const Position = (props) => {
  const {
    children,
    forcePositionY,
    positionY,
    positionX,
    screenReaderLabel,
    className,
    dataQa,
    scroll
  } = props;

  let element = useRef();
  const [horizontalDirection, setHorizontalDirection] = useState(positionX);
  const [verticalDirection, setVerticalDirection] = useState(positionY);

  useEffect(() => {
    const {
      top, left, height
    } = element.getBoundingClientRect();
    const { innerWidth, innerHeight } = window;
    const leftEdgePassesWindow = left < 0;
    const bottomEdgePassesWindow = top + height > innerHeight;
    const spaceRightIsGreater = innerWidth - left > left;
    let elementHeight = 'auto';
    let vDirection = positionY;
    let hDirection = positionX;

    if (leftEdgePassesWindow && spaceRightIsGreater) {
      hDirection = 'left';
    }

    if (bottomEdgePassesWindow && !forcePositionY) {
      elementHeight = top;
      vDirection = 'up';
    }

    if (scroll) {
      element.style.height = `${elementHeight}px`;
    }

    setVerticalDirection(vDirection);
    setHorizontalDirection(hDirection);
  }, [forcePositionY, positionY, positionX, scroll]);

  return (
    <div
      data-qa={dataQa}
      ref={node => { element = node; }}
      className={classNames({
        [className]: true,
        'direction-left': horizontalDirection === 'left',
        'direction-center': horizontalDirection === 'center',
        'direction-up': verticalDirection === 'up',
        'screen-reader-label': screenReaderLabel
      })}
    >
      {children}
    </div>
  );
};

Position.propTypes = {
  children: PropTypes.node.isRequired,
  scroll: PropTypes.bool,
  forcePositionY: PropTypes.bool,
  positionX: PropTypes.string,
  positionY: PropTypes.string,
  dataQa: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  screenReaderLabel: PropTypes.bool
};

Position.defaultProps = {
  screenReaderLabel: false,
  forcePositionY: false,
  positionY: 'right',
  positionX: 'down',
  scroll: false
};

export default Position;
